import { AnimatePresence, motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { useSocket } from "../../../services/SocketContext";
import CustomImg from "../../CustomImg/CustomImg.component";
import "./modalNewBid.scss";

type ModalNewBidProps = {
  setShowNotification: (value: "newBid" | "newReward" | null) => void;
};

const ModalNewBid: React.FC<ModalNewBidProps> = ({ setShowNotification }) => {
  const socketController = useSocket();
  const [newBid, setNewBid] = useState<NewBidPopup | null>(null);

  const handleLatestBid = async (
    response:
      | { rStatus: "success"; rData: NewBidPopup }
      | { rStatus: "error"; rData: string }
  ) => {
    console.log(response);
    if (response.rStatus === "error") {
      console.log(response.rData);
      return;
    }
    setNewBid(response.rData);
    setShowNotification("newBid");
  };

  useEffect(() => {
    socketController.on("latest-bid", handleLatestBid);
    return () => {
      socketController.off("latest-bid");
    };
    // const bidder: NewBidPopup = {
    //   bidderName: "John Doe",
    //   productImage:
    //     "https://rapidauction.ams3.digitaloceanspaces.com/rapidauction/product/1715663376428.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=DO00NFXX2CJAWLF26GGD%2F20240620%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20240620T064156Z&X-Amz-Expires=3600&X-Amz-Signature=d889417ee7f19520d501e8f98e434faaddd5aa73d077c180a621517ec25658d7&X-Amz-SignedHeaders=host&x-id=GetObject",
    //   bidAmount: "R 100.00",
    //   bidderLocation: "Cape Town"
  }, [socketController]);

  // Close function
  const handleClose = () => {
    setNewBid(null);
  };

  useEffect(() => {
    if (newBid) {
      const timer = setTimeout(() => {
        handleClose();
        setShowNotification(null);
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, [newBid, setShowNotification]);

  // const showBid = setInterval(() => {
  //   if (showNotification !== "newReward") {
  //     // setNewBid(bidder);
  //     setShowNotification("newBid");
  //     setTimeout(() => {
  //       setNewBid(null);
  //     }, showTime);
  //   }
  // }, showTime * 2);

  return (
    <AnimatePresence>
      {newBid && (
        <motion.div
          exit={{ opacity: 0, translateX: "-100%" }}
          id="new_bid_popup"
          className="card fixed bottom-2 left-2 z-10 rounded-full border-2 border-slate-900 bg-secondary p-3 text-center text-sm text-base-100 opacity-90 hover:opacity-100"
        >
          {/* {t("NEW BID")} */}
          <div className="flex flex-row">
            <CustomImg
              imgSrc={newBid.productImage}
              alt="Product Image"
              className="m-auto h-10 w-10 rounded-full bg-white object-contain"
              loadingClass="rounded-full w-10 h-10"
            />
            <div className="ml-2 mr-1 font-bold">
              {newBid.bidAmount}
              <div className="font-bold">
                {newBid.nickname} - {newBid.bidderLocation}
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ModalNewBid;
